import { getGeocode, getLatLng } from "use-places-autocomplete";

export interface ILocationDetails {
  lat: number | null;
  lng: number | null;
  postalCode: string | null;
  countryCode: string | null; // Ensure countryCode is always a string
}

interface IAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export const extractLocationDetails = async (
  address: string
): Promise<ILocationDetails> => {
  try {
    const results = await getGeocode({ address });
    const { lat, lng } = getLatLng(results[0]);

    const addressComponents = results[0].address_components;

    // Find the country component
    const countryComponent = addressComponents.find(
      (component: IAddressComponent) => component.types.includes("country")
    );

    const countryCode = countryComponent.short_name;

    // Find the postal code component
    const postalCodeComponent = addressComponents.find(
      (component: IAddressComponent) => component.types.includes("postal_code")
    );
    const postalCode = postalCodeComponent
      ? postalCodeComponent.long_name
      : null;

    return { lat, lng, postalCode, countryCode };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error extracting location details:", error);
    return { lat: null, lng: null, postalCode: null, countryCode: "" };
  }
};
